import {
  CreatePublisherOptions,
  EventServicePluginError,
  JarvisEventFinishedName,
  Publisher,
  Subscriber,
} from '@jarvis/jweb-core';
import getPlugins from './getPlugins';

const publisherId = 'com.hp.jarvis.react-photobook';

// eslint-disable-next-line @typescript-eslint/ban-types
export const publishEvent = async (name: string, data: object = {}): Promise<void> => {
  try {
    console.log('events::publishEvent: %o: %o', name, data);
    const publisher = await createPublisher();
    const result = await publisher.publish(name, data);
    if (result !== undefined) {
      console.error('events::publishEvent: %o', result);
      throw new Error(`Unable to publish event`);
    }
  } catch (error) {
    console.error('events::publishEvent: %o', error);
  }
};

export const createSubscriber = async () => {
  const { EventService } = await getPlugins();
  const result = await EventService.createSubscriber();
  if ((result as EventServicePluginError).errorType !== undefined) {
    console.error('events::createSubscriber: %o', result);
    throw new Error(`Unable to create subscriber`);
  }
  return result as Subscriber;
};

export const createPublisher = async () => {
  const { EventService } = await getPlugins();
  const options: CreatePublisherOptions = {
    allowEventingFallback: true,
  };
  const result = await EventService.createPublisher(publisherId, options);
  if ((result as EventServicePluginError).errorType !== undefined) {
    console.error('events::createPublisher: %o', result);
    throw new Error(`Unable to create publisher`);
  }
  return result as Publisher;
};

export const sendFinishedEvent = async () => {
  const eventName: JarvisEventFinishedName = 'jarvisEventFinished';
  return publishEvent(eventName);
};
